module.exports = __webpack_public_path__ + "static/media/05.69b6dd71.jpg";